import RichText, {
  type StyleOverrides,
} from '@/components/ui/RichText/RichText';

import { defaultRichTextStyles, textAlignClassMap } from './constants';
import MainSliderButtonLink from './MainSliderButtonLink';
import type { MainSliderButton, TextPosition } from './types';
import { cn, getButtons } from './utils';

interface MainSliderContentProps {
  content?: string;
  buttons?: MainSliderButton[];
  button?: MainSliderButton;
  textPosition?: TextPosition;
  className?: string;
  richTextStyles?: StyleOverrides;
  buttonClassName?: string;
  buttonsClassName?: string;
  buttonAlignment?: 'self-start' | 'self-center' | 'self-end'; // Add this
}

const MainSliderContent = ({
  content,
  buttons,
  button,
  textPosition = 'center',
  className,
  richTextStyles,
  buttonClassName,
  buttonsClassName,
  buttonAlignment,
}: MainSliderContentProps) => {
  const finalButtons = getButtons(buttons, button);

  return (
    <div
      className={cn(
        'flex h-full flex-col justify-center',
        textAlignClassMap[textPosition],
        className,
      )}
    >
      {content ? (
        <RichText
          className="max-w-xl"
          styles={{
            ...defaultRichTextStyles,
            ...richTextStyles,
          }}
        >
          {content}
        </RichText>
      ) : null}

      {finalButtons.length ? (
        <div
          className={cn(
            'mt-2 flex flex-wrap gap-3',
            buttonAlignment || 'self-center', // Use the prop, default to center
            textPosition === 'center' && 'justify-center',
            textPosition === 'right' && 'justify-end',
            textPosition === 'left' && 'justify-start',
            buttonsClassName,
          )}
        >
          {finalButtons.map((buttonItem) => {
            const label = buttonItem.label;
            const href = buttonItem.href;

            if (!label) return null;

            return (
              <MainSliderButtonLink
                key={`${label}-${href}`}
                href={href}
                className={cn(
                  'text-center',
                  buttonClassName,
                  buttonItem.className,
                )}
              >
                {label}
              </MainSliderButtonLink>
            );
          })}
        </div>
      ) : null}
    </div>
  );
};

export default MainSliderContent;
